export default __webpack_public_path__ + "static/shape-fcc619654a9d14b364cb493358b9f37e.svg";